import { render, staticRenderFns } from "./edit-table-column.vue?vue&type=template&id=730b2c6c&scoped=true"
import script from "./edit-table-column.vue?vue&type=script&lang=js"
export * from "./edit-table-column.vue?vue&type=script&lang=js"
import style0 from "./edit-table-column.vue?vue&type=style&index=0&id=730b2c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730b2c6c",
  null
  
)

export default component.exports